import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { QUESTION_SUPPORT, SEARCH_SUPPORT } from '../../../constants/routes';
import mainLogo from 'images/support-showit-logo.png';
import { useTranslation } from 'react-i18next';
import { SearchIconGray, ChooseLang, MenuRightArrow, ClearSearchIcon } from 'components/Icons';
import { Accordion, Card, Button } from 'react-bootstrap';
import API from '../../../API';
import Inner from './HelpSupportInner';
import { useHistory } from 'react-router-dom';
import Search from 'views/search/Search';
import { selectAuthUser } from 'reducers/auth/auth.selectors';
import { useSelector } from 'react-redux';

const HelpSupport = () => {
  const { t } = useTranslation();
  const [response, setResponse] = useState([]);
  const [search, setSearch] = useState([]);
  const history = useHistory();
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);
  const user = useSelector(selectAuthUser);

  const [activeKey, setActiveKey] = useState('0');
  const [collapseactiveKey, collapesetActiveKey] = useState('0');

  const getHelp = () => {
    setLoading(true);
    return API.get('/faq', [])
      .then(resp => {
        setLoading(false);

        if (resp) {
          setResponse(resp);
        }
      })
      .catch(err => {});
  };
  const handleSearch = query => {
    if (searchValue === '') {
      return;
    } else {
      query = searchValue;
      setLoading(true);
      return API.post('faq/search', { query })
        .then(resp => {
          let { data } = resp;
          setLoading(false);

          resp.push(query);
          history.push({ pathname: SEARCH_SUPPORT, state: resp });
        })
        .catch(err => {});
    }
  };
  const getHelpInner = id => {
    return API.get(`/faq/${id}`, {})
      .then(resp => {
        history.push({ pathname: QUESTION_SUPPORT, state: resp });
      })
      .catch(err => {});
  };

  useEffect(() => {
    getHelp();
  }, []);

  return (
    <div className="col-12 col-md-6 support-search-container" style={{ minHeight: '100%' }}>
      <img src={mainLogo} className="support-showit-logo" alt="main-logo" />
      <p className="support-text">
        {t('hi')} @{user.name} <span> {t('how_can_we_help')}</span>
      </p>
      <div className="support-search-header">
        <input
          onKeyDown={evt => {
            if (evt.key === 'Enter') {
              handleSearch(evt.target.value);
            }
          }}
          onChange={evt => setSearchValue(evt.target.value)}
          type="text"
          value={searchValue}
          placeholder={t("find_answers")}
        />
        <button
          className="search-btn"
          onClick={evt => {
            handleSearch(evt.target.value);
          }}
        >
          <SearchIconGray />
        </button>
      </div>
      <h1 className="support-help-text">{t("looking_help")}</h1>
      <p className="support-explore-text">{t("explore_help")}</p>
      <div className="support-bottom-border" />
      <Accordion defaultActiveKey="1" onSelect={e => setActiveKey(e)} className="support-accordion-container">
        {response &&
          response.map((support,indx) => (
            <Card key={indx}>
              <Card.Header>
                <div className={`support-accordion  ${support.id}`}>
                  <Accordion.Toggle
                    id={`acordion-toggle-${support.id}`}
                    as={Button}
                    variant="link"
                    eventKey={support.id}
                  >
                    {t(support.title)}
                  </Accordion.Toggle>
                  <span className={activeKey === support.id && 'support-arrows'}>
                    {' '}
                    <ChooseLang />
                  </span>
                </div>
                <div className="support-puprle-border" />
              </Card.Header>
              {support.children.map((innerElement,indx) => (
                <Accordion.Collapse key={indx} eventKey={support.id}>
                  <Card.Body>
                    <div className="">
                      <Accordion
                        defaultActiveKey="1"
                        activeKey={collapseactiveKey}
                        onSelect={e => collapesetActiveKey(e)}
                        className="support-accordion-wrapper"
                      >
                        <Card>
                          <Card.Header>
                            <div className="support-accordion">
                              <Accordion.Toggle
                                id={`acordion-toggle-${innerElement.id - 3}`}
                                as={Button}
                                variant="link"
                                eventKey={innerElement.id - 3}
                              >
                                {innerElement.title}
                              </Accordion.Toggle>
                              <span className={collapseactiveKey === innerElement.id - 3 && 'support-arrows'}>
                                <ChooseLang style={{ transform: 'rotate(-90deg)' }} />
                              </span>
                            </div>
                          </Card.Header>
                          {innerElement.faq.map((innerElements,index) => (
                            <Accordion.Collapse key={index} eventKey={1}>
                              <Card.Body>
                                <div
                                  className="inner-element-link d-flex justify-content-between burger-link text-light-gray"
                                  onClick={() => getHelpInner(innerElements.id)}
                                >
                                  {innerElements.title}
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>
                          ))}
                        </Card>
                      </Accordion>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              ))}
            </Card>
          ))}
      </Accordion>{' '}
    </div>
  );
};

export default HelpSupport;
